(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name crewing.controller:SendAlertCtrl
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .controller('SendAlertCtrl', SendAlertCtrl);

    function SendAlertCtrl($uibModalInstance, modalParams, CrewingHelper, MessageService) {
        var vm = this;

        vm.model = {
            params: {
                message: '',
                alertDate: modalParams.day.date,
                crew: modalParams.crew.crewDTO
            }
        };

        vm.onSendAlertClick = function () {
            if (vm.form.$valid) {
                CrewingHelper.sendAlert(vm.model.params,
                    function (response) {
                        if (response.success) {
                            MessageService.success(MessageService.MESSAGES.CREWING.SUCCESS_SAVE_MESSAGE);
                            $uibModalInstance.close(vm.model.params.crew.crewId);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
            }
        };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
